module.exports = __webpack_public_path__ + "static/media/Nguyen_Viet_Huy.62151f5b.jpg";